import { RouteCreateEditController } from './routes-create-edit.directive.controller'

import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { ROUTE_SERVICE_NAME, RouteService } from '../../../../services/route'

import { CreateEditScope } from '../../../common/common.create-edit.controller'

//#region Asset Imports

import * as TEMPLATE from './routes-create-edit.tpl.html'


//#endregion


//#region Setup

export class RouteCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        ROUTE_SERVICE_NAME,
        (
            $scope: CreateEditScope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            routeService: RouteService
        ) => new RouteCreateEditController(
            $scope,
            $q,
            $timeout,
            routeService,
            RouteService.REFERENCE_TYPE,
            RouteService.SIMAX_MODULE_NAME
        )]

    controllerAs = "$ctrl"

    template = TEMPLATE
}

//#endregion
